// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.switcher {
  width: 26px;
  height: 14px;
  border-radius: 7px;
  background-color: var(--color-switcher-track-background);
  position: relative;
  cursor: pointer;
  transition: background 0.1s ease-in;
}
.switcher:hover {
  background-color: var(--color-switcher-track-background);
}
.switcher::after {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--color-white);
  position: absolute;
  left: 2px;
  top: 2px;
  transition: left 0.1s ease-in;
}
.switcher--checked {
  background-color: var(--color-accent-background-base);
}
.switcher--checked:hover {
  background-color: var(--color-accent-background-base);
}
.switcher--checked::after {
  left: 14px;
}
.switcher--disabled {
  background-color: var(--color-neutral-background-subdued);
  cursor: not-allowed;
}
.switcher--disabled:hover {
  background-color: var(--color-neutral-background-subdued);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/switcher/Switcher.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wDAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;AASF;AAPE;EACE,wDAAA;AASJ;AANE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;AAQJ;AALE;EACE,qDAAA;AAOJ;AALI;EACE,qDAAA;AAON;AAJI;EACE,UAAA;AAMN;AAFE;EACE,yDAAA;EACA,mBAAA;AAIJ;AAFI;EACE,yDAAA;AAIN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.switcher {\n  width: 26px;\n  height: 14px;\n  border-radius: 7px;\n  background-color: var(--color-switcher-track-background);\n  position: relative;\n  cursor: pointer;\n  transition: @background-transition;\n\n  &:hover {\n    background-color: var(--color-switcher-track-background);\n  }\n\n  &::after {\n    content: \"\";\n    display: block;\n    width: 10px;\n    height: 10px;\n    border-radius: 5px;\n    background-color: var(--color-white);\n    position: absolute;\n    left: 2px;\n    top: 2px;\n    transition: left 0.1s ease-in;\n  }\n\n  &--checked {\n    background-color: var(--color-accent-background-base);\n\n    &:hover {\n      background-color: var(--color-accent-background-base);\n    }\n\n    &::after {\n      left: 14px;\n    }\n  }\n\n  &--disabled {\n    background-color: var(--color-neutral-background-subdued);\n    cursor: not-allowed;\n\n    &:hover {\n      background-color: var(--color-neutral-background-subdued);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
